import Vue from 'vue'
import VueResource from 'vue-resource'
import { sync } from 'vuex-router-sync'
import router from './router'
import store from './store'
import * as filters from './filters'

import App from './App.vue'
import VueNProgress from 'vue-nprogress'

import { isLoggedIn } from './utils/cookies'

/* eslint-disable no-new */
Vue.use(VueResource)
Vue.use(VueNProgress)

sync(store, router)

const nprogress = new VueNProgress({ parent: '.nprogress-container' })

// const { state } = store
// const { config } = state

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !isLoggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
})

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

const app = new Vue({
  router,
  store,
  nprogress,
  // state,
  // config,
  render: h => h(App)
})

window.router = router
window.store = store
export { app, router, store }



// WEBPACK FOOTER //
// ./src/app.js